import "./FooterStyles.css";

import React from 'react';
import {FaHome, FaPhone, FaMailBulk, FaFacebook, FaTwitter, FaLinkedin} from "react-icons/fa";

const Footer = () => {
  return (
    <div className="footer">
        <div className="footer-container">
            <div className="left">
                <div className="location">
                    <h4><FaHome  size={20} style={{color
                        :"#fff",marginRight:"2rem"}}/>
                    
                        Budanilkantha,Kathmandu
                            </h4>
                    
                    <div className="phone">
                    <h4><FaPhone  size={20} style={{color:
                        "#fff",marginRight:"2rem"}}/>
                        +977-98606208**
                    </h4>    

                    </div>
                    <div className="email">
                    <h4><FaMailBulk  size={20} style={{color:
                        "#fff",marginRight:"2rem"}}/>
                        binaybasnet987@gmail.com
                    </h4>    

                    </div>
                </div>
            </div>
            <div className="right">
                <h4>About the comapny</h4>
                <p>This is me Binaya Basnet. CEO &
                    Founder of BinsTech.I enjoy disscussing
                    new projects and design challenges.</p>
                    <div className="socials">
                    <FaFacebook  size={30} style={{color:
                        "#fff",marginRight:"1rem"}}/>
                    <FaTwitter  size={30} style={{color:
                        "#fff",marginRight:"1rem"}}/>
                    <FaLinkedin  size={30} style={{color:
                        "#fff",marginRight:"1rem"}}/>          
                    </div>            
            </div>

        </div>
    </div>
  )
}

export default Footer